import React, { useState, useEffect, useCallback } from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Grid,
  Box,
} from '@material-ui/core'
import 'date-fns'
import FileBase from 'react-file-base64'
import { Autocomplete } from '@material-ui/lab'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers'

import { createPost, updatePost } from '../../actions/posts'
import useStyles from './styles.js'

const PopupForm = ({ open, handleClose, currentId, setCurrentId }) => {
  const [postData, setPostData] = useState({
    title: '',
    message: '',
    category: '',
    selectedFile: '',
    roomLink: '',
    roomDate: '',
    roomStart: '',
    roomEnd: '',
  })

  const post = useSelector((state) =>
    currentId
      ? state.posts.posts.find((message) => message._id === currentId)
      : null
  )
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const userNow = JSON.parse(localStorage.getItem('profile'))
  const { user } = useSelector((state) => state.user)
  const [selectedStart, setSelectedStart] = useState(new Date())
  const [selectedEnd, setSelectedEnd] = useState(new Date())

  const handleDateStart = (date) => {
    setSelectedStart(date)
    setPostData({ ...postData, roomStart: date })
  }
  const handleDateEnd = (time) => {
    setSelectedEnd(time)
    setPostData({ ...postData, roomEnd: time })
  }

  const clear = useCallback(() => {
    setCurrentId(0)
    setPostData({
      title: '',
      message: '',
      category: '',
      selectedFile: '',
      roomLink: '',
      roomDate: '',
      roomStart: '',
      roomEnd: '',
    })
  }, [setCurrentId])

  useEffect(() => {
    if (!post?.title) clear()
    if (post) setPostData(post)
  }, [clear, post])

  const handleChangeCategory = (event, value) =>
    setPostData({ ...postData, category: value })

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (currentId === 0) {
      dispatch(
        createPost(
          {
            ...postData,
            name: user?.name,
            username: userNow?.result?.username,
            avatar: user?.avatar,
          },
          history
        )
      )
    } else {
      dispatch(
        updatePost(currentId, { ...postData, name: userNow?.result?.name })
      )
    }
    clear()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='form-dialog-title'
      className={classes.dialogContainer}
    >
      <Box display={'flex'} flexDirection={'column'} minHeight={360}>
        <DialogContent>
          <form
            noValidate
            autoComplete='off'
            className={`${classes.root} ${classes.form}`}
            onSubmit={handleSubmit}
          >
            <Typography variant='h6'>
              {currentId ? 'Editing' : 'Creating'} a Room
            </Typography>

            <Grid item xs={12}>
              <TextField
                name='title'
                variant='outlined'
                label='Title'
                fullWidth
                value={postData.title}
                onChange={(e) =>
                  setPostData({ ...postData, title: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                id='category'
                options={oyeeahCategories}
                getOptionLabel={(option) => option.toString()}
                getOptionSelected={(option, value) =>
                  option.category === value.category
                }
                onChange={handleChangeCategory}
                value={postData.category}
                fullWidth
                style={{ marginRight: '16px' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name='category'
                    label='Category'
                    variant='outlined'
                  />
                )}
              />
            </Grid>
            <Typography className={classes.linkCreate} variant='body2'>
              Click this{' '}
              <a
                href='https://meet.google.com/new'
                target='_blank'
                rel='noreferrer'
              >
                link
              </a>{' '}
              to create a room link, don't forget to copy the link and paste
              here 👇
            </Typography>
            <Grid item xs={12}>
              <TextField
                name='roomLink'
                variant='outlined'
                label='Room Link'
                fullWidth
                value={postData.roomLink}
                onChange={(e) =>
                  setPostData({ ...postData, roomLink: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  label='Start Room'
                  inputVariant='outlined'
                  className={classes.roomSchedule}
                  value={currentId ? postData.roomStart : selectedStart}
                  onChange={handleDateStart}
                />
                <DateTimePicker
                  label='End Room'
                  inputVariant='outlined'
                  className={classes.roomSchedule}
                  value={currentId ? postData.roomEnd : selectedEnd}
                  onChange={handleDateEnd}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12}>
              <TextField
                name='message'
                variant='outlined'
                label='Message'
                multiline
                rows={4}
                fullWidth
                value={postData.message}
                onChange={(e) =>
                  setPostData({ ...postData, message: e.target.value })
                }
              />
            </Grid>

            <div className={classes.fileInput}>
              <Typography variant='body2'>
                Upload image/gif thumbnail file, max 1MB
              </Typography>
              <FileBase
                type='file'
                multiple={false}
                onDone={({ base64 }) =>
                  setPostData({ ...postData, selectedFile: base64 })
                }
              />
            </div>

            <Button
              className={classes.buttonSubmit}
              variant='contained'
              color='primary'
              size='large'
              type='submit'
              fullWidth
              onClick={handleClose}
            >
              Submit
            </Button>
            <Button
              variant='contained'
              className={classes.buttonClear}
              size='small'
              onClick={clear}
              fullWidth
            >
              Clear
            </Button>
          </form>
        </DialogContent>
      </Box>
      <DialogActions>
        <Button onClick={handleClose} style={{ color: '#2940d3' }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

// Top Oyeeah Categories
const oyeeahCategories = ['Study', 'Work', 'Sleep', 'Coding', 'Watching']

export default PopupForm
